import React, { useEffect } from "react";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddBrandForm from "../forms/AddBrandForm/AddBrandForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddBrandModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Додати бренд товару"
          subTitle='Додайте новий бренд товару до системи. Заповніть необхідну інформацію та натисніть "Додати".'
        ></ModalTitle>
        <AddBrandForm onApply={onApply} onClose={props.onClose} />
      </div>
    </DefaultModal>
  );
};

export default AddBrandModal;
